<template>
  <mdb-view class="public-landing overflow-auto view-gp-back">
    <mdb-mask class="gp-hp-gradient d-flex justify-content-center align-items-center overflow-auto">
      <mdb-container class="gp-intro">
        <mdb-row>
          <div class="white-text text-center text-md-left col-md-6 mt-xl-5 mb-5 animated fadeInLeft">
            <h1 class="h1-responsive font-weight-bold mt-sm-5">Welcome!</h1>
            <hr class="hr-light"/>
            <h6 class="mb-4">Ready to start? </h6>
            <p><mdb-btn style="min-width: 175px" color="white" icon="sign-in" @click="$router.push('/login')">Login</mdb-btn></p>
            <p><mdb-btn style="min-width: 175px" color="white" icon="user-plus" @click="$router.push('/register')">Register</mdb-btn></p>
            <p><mdb-btn style="min-width: 175px" color="white" icon="telescope" @click="$router.push('/explore')">Explore</mdb-btn></p>
          </div>
        </mdb-row>
        <div class="text-white text-center">
          <a class="text-white" href="" @click.prevent="$router.push('/page/tos')">Terms of Service</a>
          &nbsp; &bull; &nbsp;
          <a class="text-white" href="" @click.prevent="$router.push('/page/privacy')">Privacy Policy</a>
        </div>
      </mdb-container>
    </mdb-mask>
  </mdb-view>

</template>

<script>
import {mdbBtn, mdbCard, mdbCardBody, mdbCol, mdbContainer, mdbIcon, mdbMask, mdbRow, mdbView} from 'mdbvue';

export default {
  name: 'ezumee-public-home',
  components: {
    mdbCard,
    mdbCardBody,
    mdbBtn,
    mdbIcon,
    mdbView,
    mdbMask,
    mdbContainer,
    mdbRow,
    mdbCol
  },
  methods: {
    moreInfo() {
      window.open(process.env.PUBLIC_HOME)
    }
  }
}
</script>
<style scoped>
.public-landing {
  background-image: url("https://static.groups.place/friends3.jpg");
}
.view-gp-back {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  height: calc(100vh);
  overflow: auto;
}

.gp-hp-gradient {
  background: -moz-linear-gradient(45deg, rgba(42, 27, 161, 0.4), rgba(29, 210, 177, 0.4) 100%);
  background: -webkit-linear-gradient(45deg, rgba(42, 27, 161, 0.4), rgba(29, 210, 177, 0.4) 100%);
  background: -o-linear-gradient(45deg, rgba(42, 27, 161, 0.4), rgba(29, 210, 177, 0.4) 100%);
  background: linear-gradient(45deg, rgba(42, 27, 161, 0.4), rgba(29, 210, 177, 0.4) 100%);
}


</style>
